/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>Default console message templates</blockquote>
 *
 * @example
 * ```typescript
 * import { CONSOLE_MESSAGES } from '@shared/reporting';
 *
 * console.log(CONSOLE_MESSAGES.CONSOLE_LOGGING_FAILED); // 'Console logging failed'
 * ```
 */
export const CONSOLE_MESSAGES = {
  UNKNOWN_SERVICE_TYPE: 'Unknown service type: {type}, falling back to console',
  CONSOLE_LOGGING_FAILED: 'Console logging failed',
  FAILED_TO_LOG_EVENT: 'Failed to log event to console',
  FAILED_TO_REPORT_TO_SERVICE: 'Failed to report to {service}:',
  LOG_TEMPLATE: '[{timestamp}] {event} ({resource}) - {distinctId}'
} as const;
